export const endpoints = {
  query: '/patrol/query',
  delete: '/patrol/:id/delete',
  find: '/patrol/:id/find',
  update: '/patrol/:id/update',
  create: '/patrol/create',
}
